<template>
    <div class="main-content">

        <customModal v-if="modalData" v-show="modalData" :onModalClose="onModalClose" :onModalAccept="acceptModal"
                     :modalData="modalData"></customModal>

        <div class="card">
            <div class="card-header">
                <h5 class="inline">ЕГК коды</h5> <span
                    v-if="paginator">Всего: <strong>{{paginator.total}}</strong></span>
            </div>
            <div class="card-body">
                <div class="row search_row">
                    <div class="col-md-8">
                        <button type="button" @click="refreshCodes" class="btn btn-info">Обновить</button>
<!--                        <button type="button" @click="synchronizeCodes" class="btn btn-info">Синхронизировать</button>-->
                    </div>
                    <div class="col-md-4">
                        <form action="" @submit="searchSubmit">
                            <div class="input-group">
                                <input type="text" placeholder="Поиск..." v-model="search" class="form-control">
                                <div class="input-group-prepend">
                                    <button type="submit" class="btn btn-success">Поиск</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div>
                    <form action="">

                        <codesTable ref="recordsTable" :records="records"/>

                        <div class="text-right">
                            <paginate v-if="paginator"
                                      :page-count="paginator.last_page"
                                      :page-range="3"
                                      :margin-pages="2"
                                      :click-handler="getRecords"
                                      :prev-text="'&laquo'"
                                      :next-text="'&raquo'"
                                      :container-class="'pagination'"
                                      :prev-class="'page-item'"
                                      :prev-link-class="'page-link'"
                                      :page-class="'page-item'"
                                      :page-link-class="'page-link'"
                                      :next-class="'page-item'"
                                      :next-link-class="'page-link'"
                                      :active-class="'active green_btn'">
                            </paginate>
                            <div>
                                <button type="button" @click="ignoreCodes" class="btn btn-danger">Игнорировать</button>
                                <button type="button" @click="groupCodes" class="btn btn-info">Объединить</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import Paginate from 'vuejs-paginate'
    import customModal from '@/components/modals/customModal'
    import codesTable from '@/components/egk/codesTable'

    export default {
        components: {
            Paginate,
            customModal,
            codesTable,
        },
        data() {
            return {
                Toast: this.$swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }),
                records: null,
                paginator: null,
                search: null,
                modalData: null,
            }
        },
        mounted() {
            this.getRecords()
        },
        methods: {
            refreshCodes() {
                this.search = null
                this.getRecords();
            },
            groupCodes() {

                let codes = [];

                let elements = document.querySelectorAll('.selectedDrug');
                elements.forEach((el) => {
                    if (el.checked) codes.push(el.name);
                });

                if (!codes.length || codes.length < 2) return;

                let name = '';

                this.records.map((r) => {
                    if (r.DRUG_ID == codes[0]){
                        console.log(r.DRUG_NAME);
                        name = r.DRUG_NAME.split(' ')[0];
                    }
                });


                this.modalData = {
                    codes: codes,
                    type: 'groupCodes',
                    header: 'Вы уверены?',
                    body: 'Хотите объединить коды?',
                    inputs: [
                        {
                            name: name,
                            label: 'Имя для объединения'
                        }
                    ],
                    acceptBtnText: 'Да',
                    cancelBtnText: 'Нет'
                };
            },
            ignoreCodes() {

                let codes = [];

                let elements = document.querySelectorAll('.selectedDrug');
                elements.forEach((el) => {
                    if (el.checked) codes.push(el.name);
                });

                if (!codes.length) return;

                this.modalData = {
                    codes: codes,
                    type: 'addToIgnore',
                    header: 'Вы уверены?',
                    body: 'Хотите добавить в игнорирование выбранные коды?',
                    acceptBtnText: 'Да',
                    cancelBtnText: 'Нет'
                };
            },
            async acceptModal() {
                switch (this.modalData.type) {
                    case 'addToIgnore':
                        let {data:resp} = await api.store('/egk/addToIgone', {
                            codes: this.modalData.codes
                        })
                        this.onModalClose();
                        if (resp.success) {
                            this.Toast.fire({
                                type: 'success',
                                title: 'Сохранено'
                            })
                            this.getRecords(1);
                        } else {
                            this.Toast.fire({
                                type: 'warning',
                                title: 'Ошибка ' + resp.message
                            })
                        }
                        break;

                    case 'groupCodes':
                        let {data:respGroup} = await api.store('/egk/addToGroup', {
                            codes: this.modalData.codes,
                            name: this.modalData.inputs[0].name
                        })
                        this.onModalClose();
                        if (respGroup.success) {
                            this.Toast.fire({
                                type: 'success',
                                title: 'Сохранено'
                            })
                            this.getRecords(1);
                        } else {
                            this.Toast.fire({
                                type: 'warning',
                                title: 'Ошибка ' + respGroup.message
                            })
                        }
                        break;
                    default:
                        this.modalData = null;
                        return;
                        break;
                }
                this.modalData = null;
            },
            onModalClose() {
                this.modalData = null;
            },
            async synchronizeCodes()
            {
                let {data} = await api.index('/egk/synchronizeCodes')
                if (data.success) {
                    this.Toast.fire({
                        type: 'success',
                        title: 'Сохранено'
                    })
                    this.getRecords(1);
                } else {
                    this.Toast.fire({
                        type: 'warning',
                        title: 'Ошибка '
                    })
                }
            },
            searchSubmit(e) {
                e.preventDefault();
                e.stopPropagation();
                this.paginator.current_page = 1;
                this.getRecords(1);
            },
            async getRecords(page = null) {
                this.$refs.recordsTable.clearCheckboxes();
                let {data: r_data} = await api.index('/egk/getCodes?page=' + page + '&search=' + this.search)
                const {data, ...pagination} = r_data.records
                this.paginator = pagination
                this.records = data
            },
        }
    }
</script>

<style scoped>
    .search_row {
        padding-bottom: 15px;
    }

    .inline {
        display: inline;
    }
</style>
